<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M31.6666 35V31.6667C31.6666 29.8986 30.9643 28.2029 29.714 26.9526C28.4638 25.7024 26.7681 25 25 25H15C13.2319 25 11.5362 25.7024 10.2859 26.9526C9.03569 28.2029 8.33331 29.8986 8.33331 31.6667V35"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M20 18.3333C23.6819 18.3333 26.6666 15.3486 26.6666 11.6667C26.6666 7.98477 23.6819 5 20 5C16.3181 5 13.3333 7.98477 13.3333 11.6667C13.3333 15.3486 16.3181 18.3333 20 18.3333Z"
    stroke="#1F4321"
    stroke-width="3.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
